import invariant from 'invariant';
import { isDefined } from './helpers';
export function setInvariants(value, defaultValue, onChange, isMulti, currentValue) {
    invariant(!(isDefined(value) && isDefined(defaultValue)), 'You need to provide either value or defaultValue');
    if (isDefined(value)) {
        invariant(isDefined(onChange), 'You cannot provide a value without an onChange handler');
    }
    else if (isDefined(defaultValue)) {
        invariant(!isDefined(onChange), 'You cannot use defaultValue with onChange handler');
    }
    if (isMulti && currentValue) {
        invariant(Array.isArray(currentValue), 'You have to provide an array when using isMulti');
    }
}
//# sourceMappingURL=setInvariants.js.map